import React, { useState, useEffect, useRef } from 'react'
import Header from './Header';
import Loading from './Loading';
import { getCodeDetail, trackSharePop } from '../../Utils/blogs'
import { setCookie } from '../../Utils/cookie'

import { GIFT_CARD_SVG, COPY_OUT, LOGIN_OUT, APPLY_CODE, DISCOUNT_CODE, COPY_SVG, COPY_SUCCESS } from '../staticTypes';

const icon = (copyFlag) => {
	if (copyFlag) {
		return (
			COPY_SUCCESS
		)
	} else {
		return (
			COPY_SVG	
		)

	}
}

const CouponCode = (props) => {
	const { points } = props.data;
	const { onClick, launcherFlag, email, visitorId } = props
	const [loading, setLoading] = useState(true);
	const [code, setCode] = useState('');
	const [coupon, setCoupon] = useState('');
	const [codePoints, setCodePoints] = useState('');
	const [useFlag, setUseFlag] = useState(true);

	const [copyFlag, setCopyFlay] = useState(false)

	const [copyMessage, setCopyMessage] = useState(APPLY_CODE);


	const inputRef = useRef(null);

	useEffect(() => {
		const codeId = window.location.hash.split('?id=')[1];
		getCodeDetail(
			email,
			codeId
		).then((res) => {
			const result = res.result
			setCode(result.discountCode)
			setCoupon(result.coupon)
			setUseFlag(result.useFlag);
			setCodePoints(result.points);
			setLoading(false)

		}).catch((err) => {
			console.log(err)
		})
		return () => {
			setCode('');
			setCoupon('')
			setUseFlag(true);
			setCodePoints('');
			setLoading(true)
		};
	}, []);

	const copy = (e) => {
		inputRef.current.select();
		document.execCommand("copy");
		setCopyFlay(true);

		trackSharePop(email, visitorId, 'copy-coupon-code')

		setTimeout(() => {
			setCopyFlay(false)
		}, COPY_OUT)

		return false;
	}

	const applyCode = () => {
		inputRef.current.select();
		document.execCommand("copy");
		setCopyMessage('√')

		trackSharePop(email, visitorId, 'apply-code')

		setTimeout(() => {
			setCopyMessage(APPLY_CODE)
		}, COPY_OUT)

		setCookie(DISCOUNT_CODE, code, LOGIN_OUT);
		return false;
	}

	const ret = () => {
		return false;
	}

	return (
		<div id="coupon-code" className="coupon-code">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link="/my-reward" />

			<div className="panel-container with-wantdo-footer">
				{
					loading === false ?
						<div className="panel-card-container reward-fulfillment-card">
							<div className="card-list-container no-hover no-border">
								{
									useFlag === 'false' ? '' : <div className="use">Used</div>
								}
								<div className="card-list-item-container no-images">
									<div className="card-list-item " aria-label="{coupon}">
										<div className="card-list-item-content">
											{GIFT_CARD_SVG}
											<div className="list-item-text-wrapper">
												<div className="list-item-title">{coupon}</div>
												<div className="list-item-subtitle text-muted">{codePoints}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="card-description "><span>Use this discount code on your next order!</span></div>
							<div className="px-2 text-center">
								<div className="copy-text-container mb-5">
									<input readOnly ref={inputRef} className="coupon-code text-input text-center mx-auto w-100" type="text" tabIndex="-1" value={code} />
									<button
										onClick={copy}
										className="system-btn copy"
									>
										{
											useFlag === 'false' ?
												icon(copyFlag)
												:
												''
										}
									</button>
								</div>
								{
									useFlag === 'false' ?

										<button
											className={`btn btn-sm btn-primary w-100 copy-btn mb-2 btn-null ${useFlag === 'false' ? '' : 'disabled'}`}
											onClick={
												copyMessage === APPLY_CODE && useFlag === 'false' ?
													applyCode :
													ret
											}>{copyMessage}</button>
										:
										''
								}
							</div>
						</div>

						:
						<Loading />
				}
			</div>

		</div>
	)
}

export default CouponCode;